/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { useMemo } from "react";
import { FloodgateApi } from "api/FloodgateApi";
import { useLatestValue } from "hooks/useLatestValue";

export interface GlobalAlert {
  message: string;
  color: string;
}

export const useGlobalAlert = (): GlobalAlert | undefined => {
  let globalAlertIterable = useMemo(
    () => FloodgateApi.instance.getFeatureMetadata("global_alert_banner"),
    []
  );
  const globalAlertData = useLatestValue(globalAlertIterable);

  if (globalAlertData) {
    return JSON.parse(globalAlertData) as GlobalAlert;
  } else {
    return undefined;
  }
};
